var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MyADGElections.jinja');
require('./MyADGElections.less');

module.exports = Base.extend({

    template: template,

    events: {
    },

    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MyADGElections/MyADGElections.js
// module id = 220
// module chunks = 0